var _text, _text2, _text3, _text4, _text5, _text6, _text7, _text8, _text9, _text10, _text11, _text12;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIndexCard = function SvgIndexCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 564 306"
  }, props), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate",
      fontSize: 12,
      fontFamily: "ArialMT,Arial"
    }
  }, _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "translate(40 31)"
  }, "Aufkl\xE4rung: Revista de Filosofia / Universidade Federal da Para\xEDba,")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(60 46)"
  }, "GP Teoria Cr\xEDtica e Hermen\xEAutica/UFPB/CNPq, Atividades Associadas -")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(60 61)"
  }, "v.4. n.1. (2017) - Jo\xE3o Pessoa: GP Teoria Cr\xEDtica e Hermen\xEAutica")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(60 76)"
  }, "/UFPB/CNPq, 2017 - v.")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(60 136)"
  }, "Quadrimestral. 2017")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(60 151)"
  }, "Semestral. 2016")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(60 166)"
  }, "ISSN: 2318-9428 Online")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(60 181)"
  }, "ISSN: 2358-8470 Impresso")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(60 196)"
  }, "DOI: 10.18012/ARF")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(40 241)"
  }, "1.Filosofia, Pesquisa filos\xF3fica - Peri\xF3dicos. 2.Filosofia geral - Peri\xF3dicos. I. GP Teoria")), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(40 256)"
  }, "Cr\xEDtica e Hermen\xEAutica/UFPB/CNPq. Atividades Associadas.")), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(317 286)"
  }, "CDD 105"))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1
    },
    d: "M1 1v304h562V1z"
  }));
};

export default SvgIndexCard;